export default __webpack_public_path__ + "static/successImg-4eddc5fab157394bf36ebf49b473073c.png";